/** The minimum a grid entry needs for the comparison — keeps the helper usable by any caller
 *  holding id-bearing rows, not just `Product`. */
type OrderedItem = { id: string };

/**
 * Has the working grid drifted from its baseline? Position IS the payload here: the collection
 * editor only moves, adds or removes cards, so equal ids at equal indexes means nothing changed.
 */
export function hasCollectionOrderChanged(
  current: readonly OrderedItem[],
  baseline: readonly OrderedItem[],
): boolean {
  if (current.length !== baseline.length) return true;
  return current.some((item, i) => item.id !== baseline[i]?.id);
}
